module.exports = __webpack_public_path__ + "static/media/girl-power.f1beaf1d.png";